<template>
  <div class="ele-body">
    <el-card shadow="never">
      <div class="ele-table-tool ele-table-tool-default">
        <el-button @click="add" type="primary" icon="el-icon-plus" class="ele-btn-icon" size="small">添加门禁计划</el-button>
      </div>
      <ele-data-table ref="table" :config="table" :choose.sync="choose" highlight-current-row>
        <template #default="{ index }">
          <el-table-column type="selection" width="45" align="center" fixed="left" />
          <el-table-column type="index" :index="index" width="45" align="center" fixed="left" show-overflow-tooltip />
          <el-table-column prop="times" label="时间范围" show-overflow-tooltip min-width="220" />
          <el-table-column label="星期" show-overflow-tooltip min-width="180">
            <template #default="{ row }">
              {{ formatWeek(row.week) }}
            </template>
          </el-table-column>
          <el-table-column prop="createTime" label="创建时间" show-overflow-tooltip min-width="160" />
          <el-table-column label="操作" width="130px" align="center" :resizable="false">
            <template #default="{ row }">
              <el-link @click="edit(row)" icon="el-icon-edit" type="primary" :underline="false">修改</el-link>
              <el-popconfirm title="确定要删除此门禁计划吗？" @onConfirm="remove(row)" class="ele-action">
                <el-link slot="reference" icon="el-icon-delete" type="danger" :underline="false">删除</el-link>
              </el-popconfirm>
            </template>
          </el-table-column>
        </template>
      </ele-data-table>
    </el-card>

    <el-dialog :title="editForm.id ? '修改门禁计划' : '添加门禁计划'" :visible.sync="showEdit" width="560px"
      @opened="refreshTimePickers" @closed="resetForm" :destroy-on-close="true" custom-class="ele-dialog-form"
      :lock-scroll="false">
      <el-form :model="editForm" ref="editForm" :rules="editRules" label-width="90px">
        <el-form-item label="时间范围" prop="timeRanges">
          <div v-for="(item, itemIndex) in editForm.timeRanges" :key="item.id" class="time-range-item">
            <el-time-picker :ref="'timePicker' + item.id" v-model="item.value" is-range range-separator="至"
              start-placeholder="开始时间" end-placeholder="结束时间" format="HH:mm" value-format="HH:mm" :editable="false"
              class="time-range-picker" @visible-change="onTimePickerVisibleChange(item.id, $event)" />
            <el-button v-if="editForm.timeRanges && editForm.timeRanges.length > 1" @click="removeTimeRange(itemIndex)"
              type="danger" icon="el-icon-delete" circle size="small" />
          </div>
          <el-button @click="addTimeRange" type="text" icon="el-icon-plus">添加时间段</el-button>
        </el-form-item>
        <el-form-item label="星期" prop="week">
          <el-select v-model="editForm.week" placeholder="请选择星期" style="width: 100%">
            <el-option v-for="item in weekOptions" :key="item.value" :label="item.label" :value="item.value" />
          </el-select>
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button @click="showEdit = false">取消</el-button>
        <el-button type="primary" @click="save">保存</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { delAccessControlPlan, saveAccessControlPlan } from '@/config/api';

export default {
  name: 'DoorTime',
  data () {
    return {
      table: {
        url: '/accessControlPlan/list',
        method: 'GET',
        where: {},
        parseData (res) {
          if (res.resCode == 200) res.code = 0;
          if (Array.isArray(res.data)) {
            res.count = res.data.length;
          } else if (res.data && Array.isArray(res.data.records)) {
            res.count = res.data.total;
            res.data = res.data.records;
          } else {
            res.count = 0;
            res.data = [];
          }
          return res;
        },
      },
      choose: [],
      showEdit: false,
      editForm: {
        id: undefined,
        timeRanges: [],
        week: '',
      },
      timeRangeIndex: 0,
      weekOptions: [
        { label: '周一', value: '1' },
        { label: '周二', value: '2' },
        { label: '周三', value: '3' },
        { label: '周四', value: '4' },
        { label: '周五', value: '5' },
        { label: '周六', value: '6' },
        { label: '周日', value: '7' },
      ],
      editRules: {
        timeRanges: [{ validator: (rule, value, callback) => this.validateTimeRanges(value, callback), trigger: 'change' }],
        week: [{ required: true, message: '请选择星期', trigger: 'change' }],
      },
    };
  },
  methods: {
    add () {
      this.editForm = this.getDefaultForm();
      this.showEdit = true;
    },
    edit (row) {
      this.editForm = {
        id: row.id,
        timeRanges: this.parseTimes(row.times),
        week: this.parseWeek(row.week),
      };
      this.showEdit = true;
    },
    save () {
      this.$refs['editForm'].validate((valid) => {
        if (!valid) return false;
        const loading = this.$loading({ lock: true });
        let formData = new FormData();
        formData.append('times', this.stringifyTimes(this.editForm.timeRanges));
        formData.append('week', this.editForm.week);
        if (this.editForm.id !== undefined && this.editForm.id !== null && this.editForm.id !== '') {
          formData.append('id', this.editForm.id);
        }
        saveAccessControlPlan(formData)
          .then((res) => {
            loading.close();
            if (res.data.resCode == 200) {
              this.showEdit = false;
              this.$message({ type: 'success', message: res.data.resMsg });
              this.$refs.table.reload();
            } else {
              this.$message.error(res.data.resMsg);
            }
          })
          .catch((e) => {
            loading.close();
            this.$message.error(e.message);
          });
      });
    },
    remove (row) {
      const loading = this.$loading({ lock: true });
      let formData = new FormData();
      formData.append('id', row.id);
      delAccessControlPlan(formData)
        .then((res) => {
          loading.close();
          if (res.data.resCode == 200) {
            this.$message({ type: 'success', message: res.data.resMsg });
            this.$refs.table.reload();
          } else {
            this.$message.error(res.data.resMsg);
          }
        })
        .catch((e) => {
          loading.close();
          this.$message.error(e.message);
        });
    },
    addTimeRange () {
      const timeRanges = Array.isArray(this.editForm.timeRanges) ? this.editForm.timeRanges.slice() : [];
      const timeRange = this.createTimeRange(new Date(), new Date());
      timeRanges.push(timeRange);
      this.$set(this.editForm, 'timeRanges', timeRanges);
      this.$forceUpdate();
      this.updateTimePickerPopper(timeRange.id);
    },
    removeTimeRange (index) {
      const timeRanges = this.editForm.timeRanges.slice();
      timeRanges.splice(index, 1);
      if (!timeRanges.length) {
        timeRanges.push(this.createTimeRange());
      }
      this.$set(this.editForm, 'timeRanges', timeRanges);
      this.$forceUpdate();
    },
    onTimePickerVisibleChange (id, visible) {
      if (visible) {
        this.updateTimePickerPopper(id);
      }
    },
    refreshTimePickers () {
      this.$nextTick(() => {
        this.editForm.timeRanges.forEach((item) => {
          this.updateTimePickerPopper(item.id);
        });
      });
    },
    updateTimePickerPopper (id) {
      this.$nextTick(() => {
        setTimeout(() => {
          const ref = this.$refs['timePicker' + id];
          const picker = Array.isArray(ref) ? ref[0] : ref;
          if (picker && picker.picker && typeof picker.picker.updatePopper === 'function') {
            picker.picker.updatePopper();
          }
        }, 50);
      });
    },
    validateTimeRanges (value, callback) {
      if (!value || !value.length) return callback(new Error('请添加时间范围'));
      const hasEmpty = value.some((item) => !item || !item.value || item.value.length !== 2 || !item.value[0] || !item.value[1]);
      if (hasEmpty) return callback(new Error('请选择完整的时间范围'));
      callback();
    },
    stringifyTimes (value) {
      return value
        .filter((item) => item && item.value && item.value.length === 2)
        .map((item) => item.value.join('-'))
        .join(',');
    },
    parseTimes (times) {
      if (!times) return [this.createTimeRange()];
      const timeRanges = String(times)
        .split(',')
        .map((item) => item.split('-'))
        .filter((item) => item.length === 2)
        .map((item) => this.createTimeRange(item));
      return timeRanges.length ? timeRanges : [this.createTimeRange()];
    },
    parseWeek (week) {
      if (Array.isArray(week)) return week.length ? String(week[0]) : '';
      if (!week && week !== 0) return '';
      return String(week)
        .split(',')
        .filter((item) => item !== '')
        .map(String)[0] || '';
    },
    formatWeek (week) {
      const weekValue = this.parseWeek(week);
      return (this.weekOptions.find((weekItem) => weekItem.value === weekValue) || {}).label || weekValue;
    },
    getDefaultForm () {
      return {
        id: undefined,
        timeRanges: [this.createTimeRange(new Date(), new Date())],
        week: '',
      };
    },
    createTimeRange (value) {
      this.timeRangeIndex += 1;
      return {
        id: 'timeRange_' + this.timeRangeIndex,
        value: value || [],
      };
    },
    resetForm () {
      this.editForm = this.getDefaultForm();
      if (this.$refs['editForm']) {
        this.$refs['editForm'].resetFields();
      }
    },
  },
};
</script>

<style scoped>
.time-range-item {
  display: flex;
  align-items: center;
  margin-bottom: 10px;
}

.time-range-picker {
  width: 360px;
  margin-right: 10px;
}
</style>
